import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaEnvelope, FaTimes } from "react-icons/fa";
import "./PlanaDocente.css";

//  Importa foto de perfil
import defaultPhoto from "../assets/nosotros/plana_docente/perfil.jpg";
import azahuanche from "../assets/nosotros/plana_docente/azahuanche.jpg";
import medina from "../assets/nosotros/plana_docente/medina.jpg";
import zuñiga from "../assets/nosotros/plana_docente/zuñiga.jpg";
import apari from "../assets/nosotros/plana_docente/apari.jpg";
import karina from "../assets/nosotros/plana_docente/karina.jpg";
import gutierrez from "../assets/nosotros/plana_docente/gutierrez.jpg";
import huanasca from "../assets/nosotros/plana_docente/huanasca.jpg";
import huanca from "../assets/nosotros/plana_docente/huanca.jpg";
import monares from "../assets/nosotros/plana_docente/monares.jpg";
import padilla from "../assets/nosotros/plana_docente/padilla.jpg";
import ferro from "../assets/nosotros/plana_docente/ferro.jpg";
import huailla from "../assets/nosotros/plana_docente/huailla.jpg";
import meza from "../assets/nosotros/plana_docente/meza.jpg";
import negron from "../assets/nosotros/plana_docente/negron.jpg";
import ramirez from "../assets/nosotros/plana_docente/ramirez.jpg";
import razo from "../assets/nosotros/plana_docente/razo.jpg";
import huaracha from "../assets/nosotros/plana_docente/huaracha.jpg";
import quihui from "../assets/nosotros/plana_docente/quihui.jpg";
import cabrera from "../assets/nosotros/plana_docente/cabrera.jpg";
import palomares from "../assets/nosotros/plana_docente/palomares.jpg";
import pillaca from "../assets/nosotros/plana_docente/pillaca.jpg";
import rojas from "../assets/nosotros/plana_docente/rojas.jpg";
import barzola from "../assets/nosotros/plana_docente/barzola.jpg";
import lucas from "../assets/nosotros/plana_docente/lucas.jpg";
import fernandez1 from "../assets/nosotros/plana_docente/fernandez1.jpg";
import ynguil from "../assets/nosotros/plana_docente/ynguil.jpg";
import hernandez from "../assets/nosotros/plana_docente/hernandez.jpg";
import miranda from "../assets/nosotros/plana_docente/miranda.jpg";
import domenica from "../assets/nosotros/plana_docente/domenica.jpg";
import vilchez_medina from "../assets/nosotros/plana_docente/vilchez_medina.jpg";
import viera from "../assets/nosotros/plana_docente/viera.jpg";
import ochoa from "../assets/nosotros/plana_docente/ochoa.jpg";
import osco from "../assets/nosotros/plana_docente/osco.jpg";
import becerra from "../assets/nosotros/plana_docente/becerra.jpg";
import luyo from "../assets/nosotros/plana_docente/luyo.jpg";
import alejo from "../assets/nosotros/plana_docente/alejo.jpg";
import gutierrez_c from "../assets/nosotros/plana_docente/gutierrez_c.jpg";
import suarez from "../assets/nosotros/plana_docente/suarez.jpg";
import soria from "../assets/nosotros/plana_docente/soria.jpg";
import sosa from "../assets/nosotros/plana_docente/sosa.jpg";
import ramos from "../assets/nosotros/plana_docente/ramos.jpg";
import calderon from "../assets/nosotros/plana_docente/calderon.jpg";






//  Importa los CV en PDF
import AZAHUANCHE from "../assets/nosotros/plana_docente/AZAHUANCHE.pdf";
import MEDINA from "../assets/nosotros/plana_docente/MEDINA.pdf";
import ZUÑIGA from "../assets/nosotros/plana_docente/ZUÑIGA.pdf";
import APARI from "../assets/nosotros/plana_docente/APARI.pdf";
import KARINA from "../assets/nosotros/plana_docente/KARINA.pdf";
import GUTIERREZ from "../assets/nosotros/plana_docente/GUTIERREZ.pdf";
import HUANASCA from "../assets/nosotros/plana_docente/HUANASCA.pdf";
import HUANCA from "../assets/nosotros/plana_docente/HUANCA.pdf";
import MONARES from "../assets/nosotros/plana_docente/MONARES.pdf";
import PADILLA from "../assets/nosotros/plana_docente/PADILLA.pdf";
import FERRO from "../assets/nosotros/plana_docente/FERRO.pdf";
import HUAILLA from "../assets/nosotros/plana_docente/HUAILLA.pdf";
import MEZA from "../assets/nosotros/plana_docente/MEZA.pdf";
import NEGRON from "../assets/nosotros/plana_docente/NEGRON.pdf";
import RAMIREZ from "../assets/nosotros/plana_docente/RAMIREZ.pdf";
import RAZO from "../assets/nosotros/plana_docente/RAZO.pdf";
import HUARACHA from "../assets/nosotros/plana_docente/HUARACHA.pdf";
import QUIHUI from "../assets/nosotros/plana_docente/QUIHUI.pdf";
import CABRERA from "../assets/nosotros/plana_docente/CABRERA.pdf";
import PALOMARES from "../assets/nosotros/plana_docente/PALOMARES.pdf";
import PILLACA from "../assets/nosotros/plana_docente/pillaca.pdf";
import ROJAS from "../assets/nosotros/plana_docente/ROJAS.pdf";
import BARZOLA from "../assets/nosotros/plana_docente/BARZOLA.pdf";
import Bastidas from "../assets/nosotros/plana_docente/Bastidas.pdf";
import Carhuancho from "../assets/nosotros/plana_docente/Carhuancho.pdf";
import Garcia_Teran from "../assets/nosotros/plana_docente/Garcia_Teran.pdf";
import Guerra from "../assets/nosotros/plana_docente/Guerra.pdf";
import Mamani from "../assets/nosotros/plana_docente/Mamani.pdf";
import Melendez from "../assets/nosotros/plana_docente/Melendez.pdf";
import Palomino_Rios from "../assets/nosotros/plana_docente/Palomino_Rios.pdf";
import Pujay from "../assets/nosotros/plana_docente/Pujay.pdf";
import Ramos_Rojas from "../assets/nosotros/plana_docente/Ramos_Rojas.pdf";
import Rojas_Puri from "../assets/nosotros/plana_docente/Rojas_Puri.pdf";
import Vilchez_Cordova from "../assets/nosotros/plana_docente/Vilchez_Cordova.pdf";
import Vilchez_Medina from "../assets/nosotros/plana_docente/Vilchez_Medina.pdf";
import Villavicencio from "../assets/nosotros/plana_docente/Villavicencio.pdf";
import Lucas from "../assets/nosotros/plana_docente/Lucas.pdf";
import FERNANDEZ from "../assets/nosotros/plana_docente/FERNANDEZ.pdf";
import YNGUIL from "../assets/nosotros/plana_docente/YNGUIL.pdf";
import HERNANDEZ from "../assets/nosotros/plana_docente/HERNANDEZ.pdf";
import CHIPANA from "../assets/nosotros/plana_docente/CHIPANA.pdf";
import MIRANDA from "../assets/nosotros/plana_docente/MIRANDA.pdf";
import DOMENICA from "../assets/nosotros/plana_docente/DOMENICA.pdf";
import VIERA from "../assets/nosotros/plana_docente/VIERA.pdf";
import OCHOA from "../assets/nosotros/plana_docente/OCHOA.pdf";
import OSCO from "../assets/nosotros/plana_docente/OSCO.pdf";
import BECERRA from "../assets/nosotros/plana_docente/BECERRA.pdf";
import LUYO from "../assets/nosotros/plana_docente/LUYO.pdf";
import ALEJO from "../assets/nosotros/plana_docente/ALEJO.pdf";
import GUTIERREZ_C from "../assets/nosotros/plana_docente/GUTIERREZ_C.pdf";
import SUAREZ from "../assets/nosotros/plana_docente/SUAREZ.pdf";
import SORIA from "../assets/nosotros/plana_docente/SORIA.pdf";
import SOSA from "../assets/nosotros/plana_docente/SOSA.pdf";
import RAMOS from "../assets/nosotros/plana_docente/RAMOS.pdf";
import CALDERON from "../assets/nosotros/plana_docente/CALDERON.pdf";



const docentesData = {

"Gestión Administrativa": [
    
    { nombre: "BECERRA BRINGAS MIGUEL ANGEL", correo: "becerra.miguel@iestpgildaballivian.edu.pe", foto: becerra, pdf: BECERRA },
    { nombre: "LUCAS TAMAYO SIDNEY ERICO", correo: "lucas.sidney@iestpgildaballivian.edu.pe", foto: lucas, pdf: Lucas },
    { nombre: "LUYO VENEGAS RUTH", correo: "luyo.ruth@iestpgildaballivian.edu.pe", foto: luyo, pdf: LUYO },
    { nombre: "MIRANDA GONZALES NEL MARTIN", correo: "miranda.nel@iestpgildaballivian.edu.pe", foto: miranda, pdf: MIRANDA },
    { nombre: "NEGRON ALVARADO ELMER AUGURIO", correo: "negron.elmer@iestpgildaballivian.edu.pe", foto: negron, pdf:NEGRON},    
    { nombre: "RAMIREZ CHUQUIHUANGA LUIS ALBERTO", correo: "ramirez.luis@iestpgildaballivian.edu.pe", foto: ramirez, pdf: RAMIREZ },
    { nombre: "RAZO QUISPE JOSE LUIS", correo: "razo.jose@iestpgildaballivian.edu.pe", foto: razo, pdf: RAZO},
    { nombre: "VILCHEZ MEDINA WALTER ARMANDO", correo: "vilchez.walter@iestpgildaballivian.edu.pe", foto: vilchez_medina, pdf:Vilchez_Medina },
    { nombre: "YNGUIL FERNANDEZ WILLIAN MARTIN", correo: "ynguil.william@iestpgildaballivian.edu.pe", foto: ynguil, pdf: YNGUIL },
    { nombre: "VIERA CHALLE PAULO OMAR ", correo: "viera.paulo@iestpgildaballivian.edu.pe", foto: viera, pdf: VIERA },
    { nombre: "OCHOA QUISPE WALTER VALENTIN", correo: "ochoa.walter@iestpgildaballivian.edu.pe", foto: ochoa, pdf: OCHOA },
  ],

  "Contabilidad": [
    { nombre: "BEYZAGA FIGUEROA CONSTANZA VIRGINIA", correo: "beyzaga.constanza@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "CHIPANA TAGLE DENNIS DANIEL", correo: "chipana.dennis@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:CHIPANA },
    { nombre: "FERNANDEZ CASTRO JORGE MARCELINO", correo: "fernandez.jorge@iestpgildaballivian.edu.pe", foto:fernandez1, pdf:FERNANDEZ },
    { nombre: "HERNANDEZ BECERRA GUILLERMO", correo: "hernandez.guillermo@iestpgildaballivian.edu.pe", foto: hernandez, pdf: HERNANDEZ },    
    { nombre: "MORENO MANCO ALFONSO CESAR", correo: "moreno.alfonso@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    
    { nombre: "OSCCO PAREDES JAIME GREGORIO", correo: "oscco.jaime@iestpgildaballivian.edu.pe", foto: osco, pdf: OSCO },
    { nombre: "RUIZ DE CASTILLA DONGO MARIA DEL ROSARIO", correo: "ruizdecastilla.maria@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "QUISPE DIAZ DOMENICA AGRIPINA", correo: "quispe.domenica@iestpgildaballivian.edu.pe", foto: domenica, pdf:DOMENICA },
  ],

  "Desarrollo de Sistemas": [
    { nombre: "APARI VALENZUELA OSCAR", correo: "apari.oscar@iestpgildaballivian.edu.pe", foto: apari, pdf: APARI },
    { nombre: "BRUNO LUCIANI ISMAEL JOSSELY", correo: "bruno.ismael@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "CARRASCO LINARES LIZARDO ALEJANDRO", correo: "carrasco.alejandro@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "ESTRADA YNDIGOYEN EDUARDO LEON", correo: "estrada.eduardo@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "GALVEZ NIÑO DE GUZMAN KORINA", correo: "galvez.karina@iestpgildaballivian.edu.pe", foto: karina, pdf:KARINA },
    { nombre: "GUTIERREZ BARAHONA JOSÉ DIÓMEDES", correo: "gutierrez.jose@iestpgildaballivian.edu.pe", foto: gutierrez, pdf: GUTIERREZ },
    { nombre: "HUANASCA RIVAS DAVID CORNELIO", correo: "huanasca.david@iestpgildaballivian.edu.pe", foto: huanasca, pdf: HUANASCA },
    { nombre: "HUANCA PACHAURI BENJAMIN", correo: "huanca.benjamin@iestpgildaballivian.edu.pe", foto: huanca, pdf: HUANCA },
    { nombre: "MONARES CHAVEZ MAURA BEATRIZ", correo: "monares.maura@iestpgildaballivian.edu.pe", foto: monares, pdf: MONARES },
    { nombre: "PADILLA OBREGON CESAR EDMUNDO", correo: "padilla.cesar@iestpgildaballivian.edu.pe", foto: padilla, pdf: PADILLA },
    { nombre: "PORTAL BAZAN PEDRO DE LOS ANGELES", correo: "portal.carlos@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "YAYA GOMEZ MARÍA EMILIA", correo: "yaya.maria@iestpgildaballivian.edu.pe", foto: defaultPhoto },
  ],



  "Construcción Civil": [
    { nombre: "ANTONIO PAZ SOLDAN AMADEO SIXTO", correo: "antonio.amadeo@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "AZAHUANCHE ASMAT VIRGINIA LIBERTAD", correo: "azahuanche.virginia@iestpgildaballivian.edu.pe", foto: azahuanche , pdf:AZAHUANCHE},
    { nombre: "BASTIDAS PINO DIONI AMADOR", correo: "bastidas.dioni@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Bastidas },
    { nombre: "GALLARDO MENDOZA JUAN CARLOS", correo: "gallardo.juan@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "HUARHUA CONTRERAS ESTAQUIO", correo: "huarhua.eustaquio@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "MEDINA OCHOA JOSE GONZALO", correo: "medina.jose@iestpgildaballivian.edu.pe", foto: medina, pdf:MEDINA },
    { nombre: "ZUÑIGA RONDINEL LEO", correo: "zuniga.leo@iestpgildaballivian.edu.pe", foto: zuñiga, pdf: ZUÑIGA},
  ],


  

  "Electricidad Industrial": [
    { nombre: "CARHUANCHO PALOMINO LUIS ENRIQUE", correo: "carhuancho.luis@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Carhuancho },
    { nombre: "FELIPE GUILLEN LUIS MIGUEL", correo: "felipe.luis@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "GARCIA TERAN PEDRO VEDA", correo: "garcia.pedro@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Garcia_Teran },
    { nombre: "GUERRA CABALLERO CARLOS RAUL", correo: "guerra.carlosc@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Guerra },
    { nombre: "HERRERA TRELLES JULIO CESAR", correo: "herrera.julio@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "MELENDEZ GALINDO LAUREANO", correo: "melendez.laureano@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Melendez },
    { nombre: "MERA ANDIA JOSE LUIS", correo: "mera.jose@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "PUJAY ACEVEDO JOEL ELISEO", correo: "pujay.joel@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Pujay },
    { nombre: "ROJAS PURIS JORGE GABRIEL", correo: "rojas.jorge@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Rojas_Puri },
    { nombre: "TALLA CONDESO ROBERTO EDGARDO", correo: "talla.roberto@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "VILLAVICENCIO RIVEROS EDWIN RICHARD", correo: "villavicencio.edwin@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "ALEJO PANEBRA MAURO JAVIER", correo: "alejo.mauro@iestpgildaballivian.edu.pe", foto: alejo, pdf: ALEJO },

  ],

  "Electrónica Industrial": [
    { nombre: "FABIAN BRAVO JOEL ENRIQUE", correo: "fabian.joel@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "FERRO QUICAÑO JOSE LUIS", correo: "ferro.jose@iestpgildaballivian.edu.pe", foto: ferro, pdf: FERRO },
    { nombre: "GALLARDO LOPEZ ALEX NOE", correo: "gallardo.alex@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "GUILLEN ROJAS ALFREDO", correo: "guillen.alfredo@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "HUAILLA ATAO DELIA CONCEPCIÓN", correo: "huailla.delia@iestpgildaballivian.edu.pe", foto: huailla, pdf: HUAILLA },
    { nombre: "INGA PEÑA AULO WILFREDO", correo: "inga.aulo@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "MEZA RODRIGUEZ FELIX CELSO", correo: "meza.felix@iestpgildaballivian.edu.pe", foto: meza, pdf: MEZA},
    { nombre: "NOLASCO SANDOVAL LUIS ALFREDO", correo: "nolasco.luis@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "RAMOS ROJAS ARTURO", correo: "ramos.arturo@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Ramos_Rojas },
    { nombre: "ROJAS CAHUA LUIS ALBERTO", correo: "rojas.luis@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "UNSIHUAY TOVAR ROBERTO FLORENTINO", correo: "unsihuay.roberto@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "VELASQUEZ CABANILLAS HECTOR FELIPE", correo: "velasquez.hector@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "VILLAVICENCIO JIMENEZ SERGIO CARLOS ANDRES", correo: "villavicencio.sergio@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Villavicencio },
  ],

  

  "Mecánica de Producción Industrial": [
    { nombre: "CALDERON CORNELIO WILMER WASHINGTON", correo: "calderon.wilmer@iestpgildaballivian.edu.pe", foto: calderon, pdf:CALDERON },    
    { nombre: "GUTIERREZ TORRES CESAR EDISON", correo: "gutierrez.cesar@iestpgildaballivian.edu.pe", foto: gutierrez_c, pdf:GUTIERREZ_C },
    { nombre: "HUARACHA CASAS RIGOBERTO PERCY", correo: "huaracha.rigoberto@iestpgildaballivian.edu.pe", foto: huaracha, pdf: HUARACHA },
    { nombre: "JURADO GUILLEN NOSSER MARIANO", correo: "jurado.nosser@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "MAMANI SANTA CRUZ ANA YOVANA", correo: "mamani.ana@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Mamani },
    { nombre: "QUIHUI YNGA FRANCISCO", correo: "quihui.francisco@iestpgildaballivian.edu.pe", foto: quihui, pdf: QUIHUI },
    { nombre: "QUISPE FLORES NEIL", correo: "quispe.neil@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "SORIA PEREZ EMILIA", correo: "soria.emilia@iestpgildaballivian.edu.pe", foto: soria, pdf: SORIA },
    { nombre: "SOSA MASGO MOISES EULOGIO", correo: "sosa.moises@iestpgildaballivian.edu.pe", foto: sosa, pdf: SOSA },
    { nombre: "VICENCIO RAMOS EFRAIN", correo: "vicencio.efrain@iestpgildaballivian.edu.pe", foto: ramos, pdf: RAMOS },
    { nombre: "SUAREZ LEANDRO JESUS ", correo: "suarez.jesus@iestpgildaballivian.edu.pe", foto: suarez, pdf: SUAREZ },
  ],

  "Mecatrónica Automotriz": [
    { nombre: "CABRERA NUÑEZ JORDAN FELIPE", correo: "cabrera.jordan@iestpgildaballivian.edu.pe", foto: cabrera, pdf: CABRERA },
    { nombre: "GASPAR PRADO JUAN WILLIAM", correo: "gaspar.juan@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "PALOMARES ANSELMO JIM ANDREW", correo: "palomares.jim@iestpgildaballivian.edu.pe", foto: palomares, pdf: PALOMARES },
    { nombre: "PALOMINO RIOS DAVID ANGEL", correo: "palomino.david@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Palomino_Rios },
    { nombre: "PILLACA DIAZ TEODORO", correo: "pillaca.teodoro@iestpgildaballivian.edu.pe", foto: pillaca, pdf: PILLACA },
    { nombre: "ROJAS SALDAÑA ALFREDO MANUEL", correo: "rojas.alfredo@iestpgildaballivian.edu.pe", foto: rojas, pdf: ROJAS },
    { nombre: "VILCHEZ CORDOVA VICENTE HEMERGILDO", correo: "vilchez.vicente@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Vilchez_Cordova },
  ],

  "Docentes de Empleabilidad": [
    { nombre: "BARZOLA QUICAÑO DORIS NANCY", correo: "barzola.doris@iestpgildaballivian.edu.pe", foto: barzola, pdf: BARZOLA },
    { nombre: "CAMARGO CAMERO JAVIER", correo: "camargo.javier@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "ESPIRITU GUERREROS JULIAN TEODORO", correo: "espiritu.julian@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "EYZAGUIRRE ESPINO JULIO CESAR", correo: "eyzaguirre.julio@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "FELIX VASQUEZ PAOLA LISSET", correo: "felix.paola@iestpgildaballivian.edu.pe", foto: defaultPhoto },    
    { nombre: "LAGOS BAUTISTA GABY LUZ", correo: "lagos.gaby@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "PAREJA PINTO FEDERICO ANTONIO", correo: "pareja.federico@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "PEREZ MENDOZA LILA JESSICA", correo: "perez.lila@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "PONCE TEJADA MARÍA DEL PILAR", correo: "ponce.maria@iestpgildaballivian.edu.pe", foto: defaultPhoto },    
    { nombre: "ROSAS RETUERTO GOMEZ VLADIMIR HERNANI", correo: "rosasretuerto.vladimir@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "SOLANO ZAPATA ELIZABETH DIANA", correo: "solano.elizabeth@iestpgildaballivian.edu.pe", foto: defaultPhoto },
  ],
};


const PlanaDocente = () => {
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const handleOpenPdf = (pdf) => {
    setSelectedPdf(pdf);
    
  };

  const handleClosePdf = () => {
    setSelectedPdf(null);
  };

  return (
    <section className="plana-docente-page">
      {/* Banner superior */}
      <div className="banner-docente">
        <div className="overlay"></div>
        <div className="text-center text-white">
          <h1 className="fw-bold">Plana Docente</h1>
          <p className="lead">
            Profesionales comprometidos con la excelencia educativa y tecnológica.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container py-5">
        {Object.keys(docentesData).map((programa, idx) => (
          <div key={idx} className="mb-5" data-aos="fade-up">
            <h2 className="programa-title">{programa}</h2>
            <div className="row g-4">
              {docentesData[programa].map((docente, i) => (
                <div className="col-6 col-md-4 col-lg-3" key={i} >
                  <div className="card-docente text-center">
                   <div className="foto-container">
                      {docente.pdf ? (
                        <img
                          src={docente.foto || defaultPhoto}
                          alt={docente.nombre}
                          className="foto-docente"
                          onClick={() => handleOpenPdf(docente.pdf)}
                          style={{ cursor: "pointer" }}
                        />
                      ) : (
                        <div className="falta-cv">
                          <img
                            src={docente.foto || defaultPhoto}
                            alt={docente.nombre}
                            className="foto-docente opacity-50"
                          />
                          <p className="text-danger fw-bold mt-2">Falta cargar CV</p>
                        </div>
                      )}
                    </div>

                    <div className="docente-info">
                      <h5>{docente.nombre}</h5>
                      <p className="correo">
                        <FaEnvelope className="me-2" />
                        {docente.correo}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/*  Modal PDF */}
      {selectedPdf && (
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div
            className="pdf-modal-content-wide"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={handleClosePdf}>
              <FaTimes size={20} />
            </button>
            <iframe
              src={`${selectedPdf}#view=FitH`}
              title="CV Docente"
              className="pdf-full-view-wide"
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default PlanaDocente;

